// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Buefy from 'buefy'
import Vuex from 'vuex'
import VueSocketIO from 'vue-socket.io'

import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/styles.css'
const moment = require('moment')
require('moment/locale/de')

// see docs for available options
const datepickerOptions = {
	colors: {
		selected: 'rgb(214, 48, 49)',
		inRange: '#e17055',
		selectedText: '#fff',
		text: '#2d3436',
		inRangeBorder: '#e17055',
		disabled: '#fff'
	},
	daysShort: ['Mo', 'Di', 'Mi', 'DO', 'Fr', 'Sa', 'So'],
	monthNames: [
		'Januar',
		'Februar',
		'März',
		'April',
		'Mai',
		'Juni',
		'Juli',
		'August',
		'September',
		'Oktober',
		'November',
		'Dezember'
	]
}

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

Vue.config.productionTip = false

Vue.use(Buefy)
Vue.use(Vuex)
Vue.use(require('vue-moment'), {
	moment
})

const store = new Vuex.Store({
	state: {
		booking: {},
		roomSettings: []
	},
	mutations: {
		setBooking (state, booking) {
			state.booking = booking
		},
		setRoomSettings (state, settings) {
			state.roomSettings = settings
		},
		setRoomType (state, settings) {
			state.booking.room = {}
			state.booking.room.roomSetting = settings
		},
		setLoading (state, status) {
			state.loading = status
		},
		arrivalUpdate (state, status) {
			state.booking.arrival_date = status
		},
		departureUpdate (state, status) {
			state.booking.departure_date = status
		},
		firstnameUpdate (state, status) {
			state.booking.firstname = status
		},
		lastnameUpdate (state, status) {
			state.booking.lastname = status
		},
		emailUpdate (state, status) {
			state.booking.email = status
		},
		phoneUpdate (state, status) {
			state.booking.phone = status
		}
	}
})

Vue.use(new VueSocketIO({
	debug: true,
	connection: '207.154.236.157:3021',
	vuex: {
		store,
		actionPrefix: 'SOCKET_',
		mutationPrefix: 'SOCKET_'
	}
}))

/* eslint-disable no-new */
window.App = new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js